import { useDispatch } from 'react-redux'
import { Button } from 'shared/components/Button/Button'
import { SimpleDialog } from 'shared/components/Dialog/SimpleDialog'
import { ExternalLink } from 'shared/components/ExternalLink/ExternalLink'
import { Pill } from 'shared/components/Pill/Pill'
import { TextV2 } from 'shared/components/Text/TextV2'
import { Handler } from 'shared/helpers/typeHelper'
import { useHelpCenterUrl } from 'shared/hooks/useHelpCenterUrl'
import { Colors } from 'shared/theme/colors'
import { TYPOGRAPHY } from 'shared/theme/typographyV2'
import styled from 'styled-components'

import { SparklesBlack } from '../../components/Icons/Icon'
import { closeConsultant } from '../../redux/actions/consultant/consultant'

interface ConsultantTermsProps {
  onSuccess: Handler
}

export function ConsultantTerms({ onSuccess }: ConsultantTermsProps) {
  const dispatch = useDispatch()
  const learnMoreLink = useHelpCenterUrl('ai-consultant')

  function handleClose() {
    dispatch(closeConsultant())
  }

  return (
    <SimpleDialog isOpen onClose={handleClose}>
      <CircledIcon>
        <img src={SparklesBlack} alt="" />
      </CircledIcon>
      <TextV2 type={TYPOGRAPHY.header2} className="mt-4 text-center">
        <div className="flex items-center justify-center gap-2">
          <span>Ask Cai</span>
          <Pill mb={0.7}>Beta</Pill>
        </div>
      </TextV2>
      <TextV2 type={TYPOGRAPHY.paragraph1} className="mt-2 mb-10 text-left">
        Cai (CloudTrucks AI) is your personal AI business consultant designed to provide general business
        guidance and information to help you run a better and more profitable trucking business. It may
        occasionally contain some errors or inaccuracies. Please keep in mind that it's not meant to replace
        professional advice. The information you share may be recorded to improve our products.{' '}
        {learnMoreLink && (
          <ExternalLink variant="paragraph1" href={learnMoreLink}>
            Learn more
          </ExternalLink>
        )}
      </TextV2>
      <Button onClick={onSuccess} size="large" margin="0 auto">
        Continue
      </Button>
    </SimpleDialog>
  )
}

const CircledIcon = styled.div`
  width: 64px;
  height: 64px;
  border: 2px solid ${Colors.darkGray};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  border-radius: 50%;
  background: ${Colors.bgGray};
`
